import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Viverano Organics' "Elephant - Organic Baby
// Lovey Security Blanket Cuddle Cloth" (p_4dj2cqw8gg), read from GET
// /api/product-reviews/product/p_4dj2cqw8gg — verbatim comment, real
// reviewer, real rating, real publish date.
export const review_vo5: FaireReviewEntity = {
  token: "review_vo5",
  type: "review",
  brandName: "Viverano Organics",
  brandToken: "b_7fghelgl",
  productToken: "p_4dj2cqw8gg",
  reviewType: "product",
  reviewerName: "Amy G.",
  reviewerLocation: "Barrington, IL",
  stars: 5,
  reviewText: "Super cute & unique. Soft organic cotton.",
  reviewDate: "Feb 24, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
